/* -----------------------------
    ACCORDION
   ----------------------------- */

class BaseAccordion extends HTMLElement {
  constructor() {
    super();

    this.onToggleClickListener = this.onToggleClick.bind(this);
    this.onWindowResizeListener = this.onWindowResize.bind(this);
  }

  static get observedAttributes() {
    return ["open"];
  }

  get selectors() {
    return {
      toggle: "[data-accordion-toggle]",
      content: "[data-accordion-content]"
    }
  }

  get open() {
    return this.hasAttribute("open");
  }

  get group() {
    return this.getAttribute("group");
  }

  connectedCallback() {
    if (this.open) {
      const currentContent = this.querySelector(this.selectors.content);
      this.adjustAccordionHeight(currentContent);
    }

    this.addEventListener("click", this.onToggleClickListener);
    window.addEventListener("resize", this.onWindowResizeListener);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onToggleClickListener);
    window.removeEventListener("resize", this.onWindowResizeListener);
  }

  toggle() {
    if (this.group) {
      const accordionsInGroup = document.querySelectorAll(`base-accordion[group="${this.group}"]`);

      accordionsInGroup.forEach((accordion) => {
        if (accordion === this) {
          return;
        }

        const otherContent = accordion.querySelector(this.selectors.content);
        this.hide(accordion, otherContent);
      });
    }

    const currentContent = this.querySelector(this.selectors.content);

    if (this.open) {
      this.hide(this, currentContent);
    } else {
      this.show(this, currentContent);
    }

    this.dispatchEvent(new CustomEvent("accordion:toggle"));
  }

  show(accordion, content) {
    content.style.maxHeight = content.scrollHeight + "px";
    accordion.setAttribute("open", "");
  }

  hide(accordion, content) {
    content.style.maxHeight = "0";
    accordion.removeAttribute("open");
  }

  adjustAccordionHeight(content) {
    content.style.maxHeight = content.scrollHeight + "px";
  }

  onToggleClick(event) {
    const clickedToggle = event.target.closest(this.selectors.toggle);

    if (!clickedToggle) {
      return;
    }

    this.toggle();
  }

  onWindowResize() {
    if (this.open) {
      const currentContent = this.querySelector(this.selectors.content);
      this.adjustAccordionHeight(currentContent);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open") {
      const currentToggle = this.querySelector(this.selectors.toggle);

      if (newValue === "") {
        currentToggle.setAttribute("aria-expanded", "true");
      } else {
        currentToggle.setAttribute("aria-expanded", "false");
      }
    }
  }
}

if (!customElements.get("base-accordion")) {
  customElements.define("base-accordion", BaseAccordion);
}
